import { Container, Grid, Typography, Link, Avatar, Stack } from '@mui/material';
import TechniciseLogo from 'images/technicise-logo.png';
import ZepintelLogo from 'images/zepintelLogo.png';
import { useTranslation } from 'react-i18next';
import { StringMap, TOptions } from 'i18next';
import { useNavigate } from 'react-router-dom';
import CustomCard from 'components/CardComponent';
export type i18translateType = {
  t: (
    key: string | TemplateStringsArray | (string | TemplateStringsArray)[],
    options?: string | TOptions<StringMap> | undefined,
  ) => string;
};
export interface MenuItemType {
  name: string;
  content: string;
  button: string;
  path: string;
  info: string;
}

export default function AdministrationDetails() {
  const { t }: i18translateType = useTranslation();
  const menuItems = t('admin', { returnObjects: true, ns: ['home'] });
  const navigate = useNavigate();
  const gotoDetails = (item: string | undefined) => {
    if (typeof item !== undefined) {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      navigate(item!);
    }
  };
  return (
    <Container sx={{ py: 25 }} maxWidth='lg'>
      <Stack direction='row' justifyContent='space-evenly' alignItems='center' spacing={2}></Stack>
      <Grid item>
        <Grid container spacing={2}>
          {(Array.isArray(menuItems) ? (menuItems as unknown as MenuItemType[]) : []).map(
            (element: MenuItemType) => (
              <Grid item key={element.name} xs={12} sm={6} md={4}>
              <CustomCard
                heading={element.name}
                subHeading={element.content}
                buttonText={element.button}
                onButtonClick={() => gotoDetails(element?.path)}
                info={element.info}
              />
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid container direction='row' justifyContent='flex-end' alignItems='flex-end' pt={7}>
        <Grid item>
          <Typography sx={{ fontWeight: 'bold' }}>{t('copy', { ns: ['home'] })} </Typography>
        </Grid>
        &nbsp; &nbsp;
        <Grid item>
          <Link href='https://technicise.com/' target='_blank'>
            <Avatar
              alt='logo'
              variant='square'
              src={TechniciseLogo}
              sx={{ width: 160, height: 70 }}
            />
          </Link>
        </Grid>
        &nbsp; &nbsp;
        <Grid item>
          <Typography sx={{ fontWeight: 'bold' }}>& </Typography>
        </Grid>
        &nbsp; &nbsp;&nbsp;
        <Grid item>
          <Link href='https://zepintel.com/' target='_blank'>
            <Avatar
              alt='logo'
              variant='square'
              src={ZepintelLogo}
              sx={{ width: 230, height: 55 }}
            />
          </Link>
        </Grid>
      </Grid>
    </Container>
  );
}
